<script>
import { Comandos } from "../../class";

export default {
    name: 'MenuRelatorios',
    props: {
        me: null
    },
    methods: {
        async solicitarConfiguracoesTodos() {
            await Comandos.solicitarConfiguracaoTodos();
                toastr.success("Solicitado de todos com sucesso!");
        }
    }
};
</script>

<template>
    <li class="dropdown mega-dropdown hidden-xs">
        <a href="#" class="dropdown-toggle "  data-toggle="dropdown">
            <i class="fa fa-file-text"></i> RELATÓRIOS <span class="caret"></span>
        </a>
        <ul class="dropdown-menu mega-dropdown-menu menu-relatorios-dropdown">
            <li class="col-sm-4 menu-section" v-if="me.admin">
                <div class="section-wrapper">
                    <div class="section-header" style="padding-left: 15px;">
                        <i class="fa fa-globe text-primary"></i>
                        <h5 class="dropdown-header">Relatórios Gerais</h5>
                    </div>
                    <ul class="section-items">
                        <li class="menu-item">
                            <a href="#/relatorios/logs" class="item-link">
                                <i class="fa fa-list-alt"></i>
                                <span>Relatório de logs no sistema</span>
                            </a>
                        </li>
                    </ul>
                    
                    <div class="section-header section-header-secondary" style="padding-left: 15px;">
                        <i class="fa fa-users text-info"></i>
                        <h5 class="dropdown-header">Clientes</h5>
                    </div>
                    <ul class="section-items">
                        <li class="menu-item">
                            <a href="#/problemas/30dias" class="item-link">
                                <i class="fa fa-clock-o"></i>
                                <span>Clientes que não acessam ao portal a 30 dias</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </li>
            
            <li class="col-sm-4 menu-section">
                <div class="section-wrapper">
                    <div class="section-header" style="padding-left: 15px;">
                        <i class="fa fa-shield text-danger"></i>
                        <h5 class="dropdown-header">Segurança</h5>
                    </div>
                    <ul class="section-items">
                        <li class="menu-item">
                            <a :href="'#/problemas/sem-transmissao'" class="item-link">
                                <i class="fa fa-signal"></i>
                                <span>Veículos sem transmissão</span>
                            </a>
                        </li>
                        <li class="menu-item">
                            <a :href="'#/problemas/gps-travado'" class="item-link">
                                <i class="fa fa-location-arrow"></i>
                                <span>Veículos com GPS travado</span>
                            </a>
                        </li>
                        <li class="menu-item">
                            <a :href="'#/problemas/oficina'" class="item-link">
                                <i class="fa fa-wrench"></i>
                                <span>Veículos em oficina</span>
                            </a>
                        </li>
                        <li class="menu-item">
                            <a :href="'#/problemas/manutencao'" class="item-link">
                                <i class="fa fa-cogs"></i>
                                <span>Veículos em manutenção</span>
                            </a>
                        </li>
                        <li class="menu-item">
                            <a :href="'#/problemas/roubados'" class="item-link">
                                <i class="fa fa-exclamation-triangle"></i>
                                <span>Veículos Roubados</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </li>
            
            <li class="col-sm-4 menu-section" v-if="me.admin">
                <div class="section-wrapper">
                    <div class="section-header" style="padding-left: 15px;">
                        <i class="fa fa-terminal text-success"></i>
                        <h5 class="dropdown-header">Comandos</h5>
                    </div>
                    <ul class="section-items">
                        <li class="menu-item">
                            <a @click="solicitarConfiguracoesTodos()" class="item-link item-link-action">
                                <i class="fa fa-refresh"></i>
                                <span>Solicitar a configuração de todos</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </li>
        </ul>
    </li>
</template>

<style scoped>
/* Menu Toggle */
.menu-relatorios-toggle {
    transition: all 0.3s ease;
}

.menu-relatorios-toggle:hover {
    background-color: rgba(255, 255, 255, 0.1) !important;
    transform: translateY(-1px);
}

/* Mega Dropdown */
.menu-relatorios-dropdown {
    min-width: 900px;
    padding: 0;
    border: none;
    border-radius: 8px;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
    background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
    overflow: hidden;
}

/* Section Styling */
.menu-section {
    border-right: 1px solid #e9ecef;
    padding: 0;
}

.menu-section:last-child {
    border-right: none;
}

.section-wrapper {
    padding: 20px 15px;
    height: 100%;
    transition: background-color 0.3s ease;
}

.section-wrapper:hover {
    background-color: rgba(248, 249, 250, 0.8);
}

/* Section Header */
.section-header {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    padding-bottom: 10px;
    border-bottom: 2px solid #e9ecef;
}

.section-header-secondary {
    margin-top: 25px;
    margin-bottom: 15px;
    padding-top: 15px;
    border-top: 1px solid #dee2e6;
}

.section-header i {
    font-size: 18px;
    margin-right: 8px;
}

.section-header h5 {
    margin: 0;
    font-weight: 600;
    font-size: 15px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: #495057;
}

/* Section Items */
.section-items {
    list-style: none;
    padding: 0;
    margin: 0;
}

.menu-item {
    margin-bottom: 5px;
}

.item-link {
    display: flex;
    align-items: center;
    padding: 10px 12px;
    text-decoration: none;
    color: #6c757d;
    border-radius: 6px;
    transition: all 0.3s ease;
    font-size: 14px;
    border-left: 3px solid transparent;
    cursor: pointer;
}

.item-link:hover {
    background-color: #e3f2fd;
    color: #1976d2;
    text-decoration: none;
    transform: translateX(5px);
    border-left-color: #1976d2;
    box-shadow: 0 2px 8px rgba(25, 118, 210, 0.15);
}

.item-link-action {
    cursor: pointer;
}

.item-link-action:hover {
    background-color: #d4edda;
    color: #155724;
    border-left-color: #28a745;
    box-shadow: 0 2px 8px rgba(40, 167, 69, 0.15);
}

.item-link i {
    font-size: 15px;
    margin-right: 10px;
    width: 18px;
    text-align: center;
    opacity: 0.7;
    transition: opacity 0.3s ease;
}

.item-link:hover i {
    opacity: 1;
}

.item-link span {
    flex: 1;
    font-weight: 500;
}

/* Custom colors for different sections */
.menu-section:nth-child(1) .item-link:hover {
    background-color: #e3f2fd;
    color: #1976d2;
    border-left-color: #2196f3;
}

.menu-section:nth-child(2) .item-link:hover {
    background-color: #ffebee;
    color: #c62828;
    border-left-color: #f44336;
}

.menu-section:nth-child(3) .item-link:hover {
    background-color: #d4edda;
    color: #155724;
    border-left-color: #28a745;
}

/* Responsive adjustments */
@media (max-width: 992px) {
    .menu-relatorios-dropdown {
        min-width: 100%;
        max-width: 100%;
    }
    
    .menu-section {
        border-right: none;
        border-bottom: 1px solid #e9ecef;
    }
    
    .menu-section:last-child {
        border-bottom: none;
    }
}

@media (min-width: 769px) and (max-width: 1200px) {
    .menu-relatorios-dropdown {
        min-width: 800px;
    }
}

/* Animation for dropdown opening */
.menu-relatorios-dropdown {
    animation: slideDown 0.3s ease-out;
}

@keyframes slideDown {
    from {
        opacity: 0;
        transform: translateY(-10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* Override global styles for this component */
.mega-dropdown {
    position: static !important;
}

.mega-dropdown-menu {
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15) !important;
    -webkit-box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15) !important;
}
</style>
